// extracted by mini-css-extract-plugin
export default {"label":"Gu5dBgyvtgyZBzXwl8sQ"};